import { Box, Button, Divider, Grid, Paper, Typography, TextField, InputAdornment, Tabs, Tab, Menu, MenuItem, InputLabel, FormControl } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useState } from 'react';
import { useStyles } from '../styles';
import AddIcon from '@mui/icons-material/Add';
import DiscoverGroupCard from '../components/DiscoverGroupCard.tsx';
import Images from '../../../Assets/assetHelper';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Utils/routes';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const YourGroups = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [category, setCategory] = React.useState('');
  const [location, setLocation] = React.useState('');

  const handleChangeCategory = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  const handleChangeLocation = (event: SelectChangeEvent) => {
    setLocation(event.target.value as string);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };
  const handleJoinClick = () => {
    navigate(`${routes.discoverGroups}/Entrepreneurs-of-Ken42`);
  };

  const members = [
    { name: 'John Doe', imageUrl: Images.Images.DefaultProfileImage },
    { name: 'Jane Smith', imageUrl: Images.Images.DefaultProfileImage },
    { name: 'Alex Johnson', imageUrl: Images.Images.DefaultProfileImage },
  ];

  const groups = Array.from({ length: 6 }, (_, index) => ({
    groupName: 'Entrepreneurs of Ken42',
    memberCount: members.length,
    members: members,
    onJoinClick: handleJoinClick,
  }));

  const handleCreateGroup: React.MouseEventHandler<HTMLButtonElement> = () => {
    navigate(routes.createGroup);
  };

  return (
    <Grid item spacing={3} height={'97%'} overflow={'hidden'}>
      <Paper className={` ${classes.DiscoverGroupContainer}`}>
        <Box className={classes.DiscoverGroupContainerHeader}>
          <Box sx={{ flex: '1' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Your groups" {...a11yProps(0)} sx={{ textTransform: 'none', fontSize: '15px', fontWeight: 500 }} />
              <Tab label="Created by you" {...a11yProps(1)} sx={{ textTransform: 'none', fontSize: '15px', fontWeight: 500 }} />
            </Tabs>
          </Box>
          <Box>
            <TextField
              placeholder="Search"
              variant="outlined"
              value={searchTerm}
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  height: '36px',
                },
                '& .MuiInputBase-input': {
                  fontSize: '12px',
                },
              }}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ fontSize: '15px' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              style={{ textTransform: 'capitalize' }}
              size="large"
              startIcon={<FilterAltOutlinedIcon style={{ fontSize: '15px' }} />}
              sx={{ borderRadius: '6px', ml: 1, backgroundColor: '#E8EBF3', color: '#373A45', height: '36px' }}
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Filters</Typography>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              PaperProps={{
                sx: {
                  width: '20vw',
                  height: '72vh',
                  padding: '20px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                },
              }}
              sx={{ mt: 2 }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: '15px' }}>Filters</Typography>
              <Box sx={{ height: '52vh' }}>
                <Box sx={{ width: '100%', mt: 3 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', marginTop: '-7px' }}>
                      Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={category}
                      label="Category"
                      onChange={handleChangeCategory}
                      sx={{
                        height: '36px',
                        borderRadius: '6px',
                        '& .MuiOutlinedInput-root': {
                          height: '36px',
                          borderRadius: '6px',
                        },
                      }}
                    >
                      <MenuItem
                        value={10}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Science
                      </MenuItem>
                      <MenuItem
                        value={20}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Technology
                      </MenuItem>
                      <MenuItem
                        value={30}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Startups
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ width: '100%', mt: 3 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', marginTop: '-7px' }}>
                      Location
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={location}
                      label="Location"
                      onChange={handleChangeLocation}
                      sx={{
                        height: '36px',
                        borderRadius: '6px',
                        '& .MuiOutlinedInput-root': {
                          height: '36px',
                          borderRadius: '6px',
                        },
                      }}
                    >
                      <MenuItem
                        value={10}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Chennai
                      </MenuItem>
                      <MenuItem
                        value={20}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Mumbai
                      </MenuItem>
                      <MenuItem
                        value={30}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Kolkata
                      </MenuItem>
                      <MenuItem
                        value={30}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Delhi
                      </MenuItem>
                      <MenuItem
                        value={30}
                        sx={{
                          '&.Mui-selected': {
                            backgroundColor: 'transparent',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          '&:active': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        Pune
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box>
                <Divider sx={{ paddingTop: '10px', color: '#BFCEFF', marginBottom: '10px' }} />
                <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'end' }}>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    size="large"
                    variant="text"
                    sx={{ borderRadius: '6px', ml: 1, fontSize: '12px', fontWeight: '500', width: '100%' }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: '6px',
                      ml: 1,
                      fontSize: '12px',
                      fontWeight: '500',
                      width: '100%',
                      boxShadow: 'none',
                      '&:hover': {
                        boxShadow: 'none',
                      },
                    }}
                    onClick={handleClose}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Menu>
            <Button
              style={{ textTransform: 'capitalize' }}
              size="large"
              variant="contained"
              startIcon={<AddIcon style={{ fontSize: '15px' }} />}
              sx={{
                borderRadius: '6px',
                ml: 1,
                boxShadow: 'none',
                height: '36px',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
              onClick={handleCreateGroup}
            >
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Create Group</Typography>
            </Button>
          </Box>
        </Box>
        <Divider sx={{ paddingTop: '10px', color: '#BFCEFF', marginBottom: '10px' }} />
        <Box className={`scrollbar-cusgray ${classes.postContainer1}`}>
          <Box
            sx={{
              marginTop: '5px',
              height: 'auto',
              paddingRight: '5px',
              overflowY: 'auto',
              paddingBottom: '50px',
            }}
          >
            <CustomTabPanel value={value} index={0}>
              <Grid container spacing={4}>
                {groups.map((group, index) => (
                  <Grid key={index} item xs={12} sm={6} md={4} lg={3} spacing={2} sx={{ cursor: 'pointer' }} onClick={handleJoinClick}>
                    <DiscoverGroupCard {...group} />
                  </Grid>
                ))}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Grid container spacing={4}>
                {groups.map((group, index) => (
                  <Grid key={index} item xs={12} sm={6} md={4} lg={3} spacing={2} sx={{ cursor: 'pointer' }} onClick={handleJoinClick}>
                    <DiscoverGroupCard {...group} />
                  </Grid>
                ))}
              </Grid>
            </CustomTabPanel>
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
};

export default YourGroups;
